/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.ActivityLog {

    export function highlight($sce: ng.ISCEService): angular.IFilterService {
        const filter = (text: any, pattern?: string): any => {
            if (!text || !pattern) {
                return $sce.trustAsHtml(text);
            }

            let higlitedText = (pattern: string): string => `<span class="highlight-description">${pattern}</span>`;
            let preparationOfText = (text: string): string => {
                // Removed tags from text
                return text ? text.trim().replace(/<[^>]+>/gm, '') : '';
            }
            let elText = preparationOfText(text);
            let preparedPatterns = _.uniq(preparationOfText(pattern).split(' '));

            var regex = new RegExp('(' + preparedPatterns.join('|') + ')', 'ig');
            return $sce.trustAsHtml(text.replace(regex, higlitedText('$&')));
        };
        return filter;
    }

    highlight.$inject = [
        '$sce'
    ];

    angular.module('meevo.plugins.activityLog')
        .filter('highlight', highlight);
}
